import React from "react";
import { styled } from "@material-ui/core";

import { FunnelModal } from "ui/funnelModal/FunnelModal";
import InfoOutline from "components/repairFunnel/assets/infoOutline.svg";
import { H4, H2, Body } from "components/design-system/atoms/Typography/";
import Box from "@material-ui/core/Box";

interface ZeroRiskModalProps {
  repairPackagePrice: number;
  trigger?: React.ReactNode;
}

const InteractiveInfoOutline = styled(InfoOutline)({
  cursor: "pointer",
});

export const ZeroRiskModal: React.FC<ZeroRiskModalProps> = ({
  repairPackagePrice,
  trigger = <InteractiveInfoOutline />,
}) => {
  return (
    <FunnelModal size="md" showDividers trigger={trigger}>
      <Box pb={4} pr={4} pl={4} textAlign="center">
        <img src="/rendez-vous-reparateur/guarantee.svg" height={70} width={70} alt="" />
        <H2 mb={2} color="secondary.main">
          Pack Zéro Risque
        </H2>
        <H4 mb={5} color="black500.main">
          Personne ne restera sur le carreau
        </H4>
        <Body mb={2}>
          Si la réparation n’est pas intéressante (pièce détachée trop chère ou produit non réparable), nous vous
          offrons <b>un bon d’achat de {repairPackagePrice / 100}€</b> pour vous permettre d’acheter sur notre MurfyShop
          un produit reconditionné par nos techniciens.
        </Body>
        <Body>
          Ainsi, vous ne prenez aucun risque à tenter de réparer votre produit avant de vous orienter vers un achat si
          nécessaire (il faudrait être fou pour ne pas essayer !)
        </Body>
      </Box>
    </FunnelModal>
  );
};

export default ZeroRiskModal;
